import CheckoutPage from './pages/CheckoutPage.vue';

const routes = [
  {
    path: '/checkout',
    name: 'store-checkout',
    component: CheckoutPage,
    meta: {
      title: 'Commander - Kingrecharges Store',
    }
  },
];

export default routes;
